/**
 * Veluna Commerce Polish - two narrow purchase-hierarchy corrections.
 * Additive only: no existing handler, price calculation, selling plan, cart
 * call or tracking hook is modified.
 *
 *  A. PDP one-time CTA copy. The label is driven by
 *     section.settings.main_cta_text ("Start My Ritual") and stays subscription-
 *     worded even when One-Time is selected. The PRICE is already correct, so
 *     this rewrites only [data-atc-label] and never touches [data-cta-price].
 *
 *  B. Quiz-result sticky timing. The section shows the sticky "whenever results
 *     are visible (always-on floating CTA)", so it covers the viewport from
 *     load, before the visitor has seen the in-flow CTA. This suppresses it via
 *     a higher-specificity body class - the same technique the theme already
 *     uses for body.mr-sheet-active - so the existing checkSticky() logic is
 *     left completely alone rather than fought.
 */
(function (w, d) {
  'use strict';
  if (w.VelunaCommercePolish) return;
  w.VelunaCommercePolish = { version: 1 };

  /* ---------- A. PDP one-time CTA copy ---------- */
  function ctaCopy() {
    var btn = d.getElementById('recovery-cream-add-to-cart');
    if (!btn) return;
    var label = btn.querySelector('[data-atc-label], .recovery-cream-hero__cta-text');
    if (!label) return;
    var baseline = btn.getAttribute('data-veluna-atc-baseline-label') || 'Start My Ritual';
    var ONE_TIME = 'Add to Cart';

    function selectedType() {
      var r = d.querySelector('[data-velunasub-purchase-type]:checked');
      return r ? r.value : 'subscribe';
    }
    function apply() {
      var want = selectedType() === 'onetime' ? ONE_TIME : baseline;
      if (label.textContent.trim() !== want) label.textContent = want;
    }

    d.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-velunasub-purchase-type]')) {
        w.setTimeout(apply, 0);
      }
    }, true);
    d.addEventListener('click', function (e) {
      try {
        if (e.target.closest && e.target.closest('.recovery-cream-hero__purchase-type-option')) {
          w.setTimeout(apply, 60);
        }
      } catch (_) {}
    }, true);

    /* The theme re-syncs the button after cart-drawer close; re-assert then,
       but only on label mutations so we never loop against the price sync. */
    if (w.MutationObserver) {
      var guard = false;
      new w.MutationObserver(function () {
        if (guard) return;
        guard = true;
        w.setTimeout(function () { apply(); guard = false; }, 0);
      }).observe(label, { childList: true, characterData: true, subtree: true });
    }
    apply();
  }

  /* ---------- B. Quiz-result sticky timing ---------- */
  function stickyTiming() {
    var sticky = d.getElementById('mr-v2-sticky');
    var primary = d.getElementById('mr-cta');
    if (!sticky || !primary || !w.IntersectionObserver) return;

    if (!d.getElementById('vln-sticky-timing-css')) {
      var st = d.createElement('style');
      st.id = 'vln-sticky-timing-css';
      st.textContent =
        'body.vln-sticky-suppressed #mr-v2-sticky{' +
        'transform:translateY(140%)!important;pointer-events:none!important;}' +
        '@media(min-width:768px){body.vln-sticky-suppressed #mr-v2-sticky{' +
        'transform:translate(-50%,140%)!important;}}';
      d.head.appendChild(st);
    }

    var reachedCommerce = false;
    var primaryInView = true;   /* assume in view until told otherwise */

    function paint() {
      /* Sticky earns its place only once the visitor has reached the commerce
         area AND the in-flow CTA has left the useful viewport. */
      var suppress = primaryInView || !reachedCommerce;
      d.body.classList.toggle('vln-sticky-suppressed', suppress);
    }

    new w.IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        primaryInView = en.isIntersecting;
        if (en.isIntersecting) reachedCommerce = true;
      });
      paint();
    }, { threshold: 0.35 }).observe(primary);

    var commerce = d.querySelector('[data-mr-purchase-type]');
    if (commerce) {
      new w.IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) reachedCommerce = true; });
        paint();
      }, { threshold: 0.2 }).observe(commerce);
    }
    paint();
  }

  function start() { try { ctaCopy(); } catch (_) {} try { stickyTiming(); } catch (_) {} }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
  /* The result page renders its commerce block after the recommendation
     resolves, so re-run once the DOM settles. */
  w.setTimeout(start, 1500);
  w.setTimeout(start, 4000);
})(window, document);
